import { experimental_extendTheme as extendTheme } from "@mui/material/styles";
import { red } from "@mui/material/colors";

const fontFamily = [
  "-apple-system",
  "BlinkMacSystemFont",
  '"Segoe UI"',
  "Roboto",
  '"Helvetica Neue"',
  "Arial",
  "sans-serif",
  '"Apple Color Emoji"',
  '"Segoe UI Emoji"',
  '"Segoe UI Symbol"',
].join(",");

// Both palettes are emitted as CSS variables during SSR and selected by a
// prefers-color-scheme media query, so the first paint is already in the right
// mode. A theme derived from useMediaQuery cannot do that: the server has no
// media query to evaluate, so it always renders light and swaps on hydration.
// See docs/Dark Mode.md for the full picture.
export function createCustomTheme() {
  return extendTheme({
    typography: { fontFamily },

    colorSchemes: {
      light: {
        palette: {
          primary: { main: "#7f4e82" },
          secondary: { main: "#5D9943" },
          error: { main: red.A400 },
        },
      },
      dark: {
        palette: {
          primary: { main: "#a880af" },
          secondary: { main: "#5D9943" },
          error: { main: red.A400 },
        },
      },
    },
  });
}
